import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { useApi } from "../../../../hooks/useApi";
import Loader from "../../../DefaultStyles/Loader";
import { OptionType } from "../../../Filters/DropDown";
import { DeleteModalLabel } from "../../Users/UserDetail/CommentModal/CommentDeleteModal";
import TemplatePreviewBox from "./TemplatePreviewBox";
import SelectAccountModal from "./SelectAccountModal";
import { IAlertEvt } from "../../../../ApiTS/CommonType";
import {
  getKkoTemplateData,
  GetServiceSetData_V3,
  GetSubscriptionSetData_V3,
} from "../../../../ApiTS/ServiceDatasTS_V3";
import { getString3ByKey } from "../../../../AdminApi/3.0_utils";

interface PreviewSectionProps {
  templateValue: OptionType;
  subsValue: OptionType;
  targetUid: string;
  type: string | undefined;
  previewValue?: string;
  setPreviewValue: Dispatch<SetStateAction<string | undefined>>;
  roleFilteredAlertData: IAlertEvt[];
  userAccount?: string;
}

export const alimTalkInputValue = atom<string>({
  key: "alimTalkInputValue",
  default: "",
});

export const alimTalkPreviewBtnClick = atom<boolean>({
  key: "alimTalkPreviewBtnClick",
  default: false,
});

export const alimTalkTitle = atom<string | undefined | null>({
  key: "alimTalkTitle",
  default: "",
});

export const selectedAccountIdAtom = atom<string>({
  key: "selectedAccountIdAtom",
  default: "",
});

export default function PreviewSection({
  templateValue,
  subsValue,
  targetUid,
  type,
  previewValue,
  setPreviewValue,
  roleFilteredAlertData,
  userAccount,
}: PreviewSectionProps) {
  const [selectAccountModal, setSelectAccountModal] = useState(false);

  const [inputValue, setInputValue] = useRecoilState(alimTalkInputValue);
  const [previewBtnClick, setPreviewBtnClick] = useRecoilState(
    alimTalkPreviewBtnClick
  );
  const setTitle = useSetRecoilState(alimTalkTitle);

  const [tempAccountService, setTempAccountService] = useState(false);
  const selectedAccountId = useRecoilValue(selectedAccountIdAtom);

  const subsData = GetSubscriptionSetData_V3(Number(subsValue?.value ?? 0));

  const { response, loading } = useApi({
    method: "get",
    url: tempAccountService
      ? `temp-account?servid=${subsData?.SVC_ID}`
      : undefined,
  });

  console.log("🧡", selectedAccountId);

  console.log(response);

  console.log(inputValue);

  // 템플릿 미리보기
  useEffect(() => {
    if (previewBtnClick) {
      console.log(templateValue);

      const userEvtId = Number(templateValue?.value);
      const alerEvtData = roleFilteredAlertData?.find(
        (a) => a.USEREVT_ID === userEvtId
      );
      const template = getKkoTemplateData(alerEvtData?.KKO_TPLID!);

      console.log(template);

      const subsId = Number(subsValue?.value) ?? 0;
      const subsData = GetSubscriptionSetData_V3(subsId);
      const svcId = subsData?.SVC_ID ?? 0;
      const svcData = GetServiceSetData_V3(svcId);

      setPreviewValue(
        template?.KKO_DESC?.replace(/#{user_nm}/g, targetUid?.split("_")[1])
          ?.replace(/#{user_nick}/g, targetUid?.split("_")[2])
          ?.replace(/#{svc_nm}/g, getString3ByKey(svcData?.SVC_NM ?? 0))
          ?.replace(/#{subs_nm}/g, subsValue?.label ?? "") ?? ""
      );

      if (template?.KKO_DESC?.includes("임시 계정 안내")) {
        setTempAccountService(true);
      }

      setInputValue(
        getString3ByKey(alerEvtData?.ADM_PRST!)
          ?.replaceAll("{subs_nm}", subsValue?.label ?? "")
          ?.replaceAll("{svc_nm}", getString3ByKey(svcData?.SVC_NM ?? 0))
          ?.replaceAll("{inviteinfo}", userAccount ?? "")
      );
      setPreviewBtnClick(false);
    }
  }, [previewBtnClick, templateValue?.value]);

  useEffect(() => {
    if (response?.status === 200) {
      if (response?.data?.length > 0) {
        setSelectAccountModal(true);
      }

      setTempAccountService(false);
    }
  }, [response]);

  useEffect(() => {
    const selectedAccount = response?.data?.find(
      (d: { id: string }) => d.id === selectedAccountId
    );

    console.log("💛", selectedAccount);

    const userEvtId = Number(templateValue?.value);
    const alerEvtData = roleFilteredAlertData?.find(
      (a) => a.USEREVT_ID === userEvtId
    );

    if (selectedAccount) {
      setInputValue(
        getString3ByKey(alerEvtData?.ADM_PRST!)
          ?.replaceAll("{subs_nm}", subsValue?.label ?? "")
          ?.replaceAll("{tempinfo_mtd}", selectedAccount?.type)
          ?.replaceAll("{tempinfo_id}", selectedAccount?.email)
          ?.replaceAll("{tempinfo_pw}", selectedAccount?.pw)
          ?.replaceAll("{tempinfo_adpw}", selectedAccount?.pin)
          ?.replaceAll("{templmt}", dayjs().format("YY년 M월 D일 자정"))
      );
    }
  }, [selectedAccountId]);

  return (
    <>
      <DeleteModalLabel>
        {type === "input" ? "미리보기" : "내용"}
      </DeleteModalLabel>

      <TemplatePreviewBox
        previewValue={previewValue}
        inputValue={inputValue}
        setInputValue={setInputValue}
      />

      {loading && <Loader />}

      {selectAccountModal && (
        <SelectAccountModal
          closeEvent={() => setSelectAccountModal(false)}
          accountList={response?.data}
        />
      )}
    </>
  );
}
